exports.components = {
  "component---cache-caches-gatsby-plugin-offline-app-shell-js": () => import("./../../caches/gatsby-plugin-offline/app-shell.js" /* webpackChunkName: "component---cache-caches-gatsby-plugin-offline-app-shell-js" */),
  "component---src-templates-panels-page-jsx": () => import("./../../../src/templates/panels-page.jsx" /* webpackChunkName: "component---src-templates-panels-page-jsx" */)
}

